import {LocalDate} from '@js-joda/core';
import {Periodicity} from './salary';

export class PayrollDate {
  public date?: LocalDate;
  public periodicity?: Periodicity;
}
